import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { analyticsIdentifyUser } from '../api/services/Analytics';
import { useAuthQuery } from '../auth/hooks/useAuthQuery';

export const useAnalyticsIdentify = () => {
  const location = useLocation();
  const { user } = useAuthQuery();

  useEffect(() => {
    if (user && location.pathname !== '/' && location.pathname !== '/login') {
      analyticsIdentifyUser(user);
    }
  }, [user, location.pathname]);
};
